import { createReducer } from 'utils/ReduxUtils';

import * as actions from '../../actionTypes/general';
import type { FileData, RemoveDocumentAction, UploadDocumentAction, UploadDocumentFailureAction, UploadDocumentSuccessAction } from '../../types';

type Slice = { isUploading: boolean; byId: { [id: string]: FileData } };
type GeneralState = { [name: string]: Slice };

const emptySlice: Slice = { isUploading: false, byId: {} };

const initialState: GeneralState = {
  'generalTermsConditionsLink.AFTER_SALES': emptySlice,
  'generalTermsConditionsLink.PARTS': emptySlice,
  'generalTermsConditionsLink.SALES': emptySlice,
  confidentialityPolicy: emptySlice,
};

const reset = (): GeneralState => initialState;

const setRequest = (state: GeneralState, { payload }: UploadDocumentAction): GeneralState => ({
  ...state,
  [payload.name]: { ...state[payload.name], isUploading: true },
});

const setFailure = (state: GeneralState, { payload }: UploadDocumentFailureAction): GeneralState => ({
  ...state,
  [payload.name]: { ...state[payload.name], isUploading: false },
});

const setSuccess = (state: GeneralState, { payload: document }: UploadDocumentSuccessAction): GeneralState => ({
  ...state,
  [document.name]: {
    ...state[document.name],
    isUploading: false,
    byId: { ...state[document.name]?.byId, [document.id]: document },
  },
});

const removeDocument = (state: GeneralState, { payload }: RemoveDocumentAction): GeneralState => {
  const { [payload.id]: _deletedId, ...ids } = state[payload.name]?.byId ?? {};

  return {
    ...state,
    [payload.name]: {
      ...state[payload.name],
      byId: ids,
    },
  };
};

export default createReducer(initialState, {
  [actions.RESET_DOCUMENTS]: reset,
  [actions.UPLOAD_DOCUMENT]: setRequest,
  [actions.UPLOAD_DOCUMENT_SUCCESS]: setSuccess,
  [actions.UPLOAD_DOCUMENT_FAILURE]: setFailure,
  [actions.REMOVE_DOCUMENT]: removeDocument,
});
